import React, { useEffect, useState } from 'react';

const NewsFlashBanner = () => {
  const [newsFlashes, setNewsFlashes] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const fetchNewsFlashes = async () => {
      try {
        const response = await fetch('https://fetc.in/api/v1/news-flash');
        const data = await response.json();
        const activeNews = data.filter(news => news.isActive);
        setNewsFlashes(activeNews);
      } catch (err) {
        console.error('Failed to fetch news flashes:', err);
      }
    };

    fetchNewsFlashes();
  }, []);

  useEffect(() => {
    if (newsFlashes.length === 0) return;

    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % newsFlashes.length);
    }, 25000); 

    return () => clearInterval(interval);
  }, [newsFlashes]);

  if (newsFlashes.length === 0) {
    return null;
  }

  return (
    <>
      <style>{`
        @keyframes scrollMessage {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      <div className="left-0 w-full bg-yellow-300 z-40 border-b border-gray-300">
        <div className="max-w-7xl mx-auto overflow-hidden relative h-6 px-4">
          <p className="whitespace-nowrap animate-[scrollMessage_25s_linear_infinite] font-semibold text-black text-sm">
            {newsFlashes[currentMessageIndex].message}
          </p>
        </div>
      </div>
    </>
  );
};

export default NewsFlashBanner;
